import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Landing from "./pages/Landing";
import Shop from "./pages/Shop";
import SmallBusiness from "./pages/SmallBusiness";
import StartupScoping from "./pages/StartupScoping";
import { CartProvider } from "./contexts/CartContext";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import { QueryClient, QueryClientProvider } from "react-query";

const options = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: "30px",
  // you can also just use 'scale'
  transition: transitions.SCALE,
};

const queryClient = new QueryClient();

class Platform extends Component {
  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <AlertProvider template={AlertTemplate} {...options}>
          <CartProvider>
            <BrowserRouter>
              <Switch>
                <Route path="/landing/" component={Landing} />
                <Route path="/smallbusiness/" component={SmallBusiness} />
                <Route path="/project-scoping/" component={StartupScoping} />
                <Route path="/shop/" component={Shop} />
                <Route
                  exact
                  path="/"
                  render={() => <Redirect to="/landing" />}
                />
              </Switch>
            </BrowserRouter>
          </CartProvider>
        </AlertProvider>
      </QueryClientProvider>
    );
  }
}

export default Platform;
